"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _color = _interopRequireDefault(require("color"));

var _Popover = _interopRequireDefault(require("./Popover"));

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

var _class, _class2, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Info = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Info, _Component);

  var _super = _createSuper(Info);

  function Info() {
    var _this;

    (0, _classCallCheck2["default"])(this, Info);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(Info, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          size = _this$props.size,
          sentiment = _this$props.sentiment,
          className = _this$props.className,
          popoverProps = (0, _objectWithoutProperties2["default"])(_this$props, ["text", "size", "sentiment", "className"]);
      var position = popoverProps.position || "top center";
      var popoverContent = text || popoverProps.popoverContent;

      if (!popoverContent) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _styling.css)(this.styles.root, className)
        }, "i");
      }

      var popoverMaxWidth = popoverProps.popoverMaxWidth || 250;
      return /*#__PURE__*/_react["default"].createElement(_Popover["default"], (0, _extends2["default"])({}, popoverProps, {
        position: position,
        popoverContent: popoverContent,
        popoverMaxWidth: popoverMaxWidth
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, "i"));
    }
  }, {
    key: "styles",
    get: function get() {
      var fonts = this.context.theming.fonts;
      var _this$props$size = this.props.size,
          size = _this$props$size === void 0 ? 16 : _this$props$size;
      var borderColor = new _color["default"](this.backgroundColor).darken(0.5);
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: this.textColor,
          width: size,
          height: size,
          maxHeight: size,
          // eslint-disable-next-line local-rules/validate-root
          maxWidth: size,
          fontSize: 0.75 * size,
          fontFamily: fonts.bold,
          backgroundColor: this.backgroundColor,
          border: borderColor.toString(),
          borderRadius: "50%",
          textAlign: "center",
          verticalAlign: "middle",
          textDecoration: "none",
          opacity: 1
        }
      });
    }
  }, {
    key: "backgroundColor",
    get: function get() {
      var _this$context$theming = this.context.theming.theme,
          positive = _this$context$theming.positive,
          warning = _this$context$theming.warning,
          negative = _this$context$theming.negative;
      var sentimentProp = this.props.sentiment;
      var sentiment = sentimentProp || "info";

      switch (sentiment) {
        case "success":
          return positive;

        case "warning":
          return warning;

        case "error":
          return negative;

        default:
          return "rgba(175, 199, 209, 0.4)";
      }
    }
  }, {
    key: "textColor",
    get: function get() {
      var _this$props$sentiment = this.props.sentiment,
          sentiment = _this$props$sentiment === void 0 ? "info" : _this$props$sentiment;
      var _this$context$theming2 = this.context.theming.theme,
          textWhite = _this$context$theming2.textWhite,
          textBlack = _this$context$theming2.textBlack;

      switch (sentiment) {
        case "success":
          return textWhite;

        case "warning":
          return textBlack;

        case "error":
          return textWhite;

        default:
          return textBlack;
      }
    }
  }]);
  return Info;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = _objectSpread({
  size: {
    required: false,
    type: "number",
    defaultValue: "16",
    description: "Determines how large the tip is"
  },
  sentiment: {
    required: false,
    defaultValue: "info",
    type: "\"success\" | \"warning\" | \"error\" | \"info\"",
    description: "Sentiment of the tip - determines the color treatment"
  }
}, _Popover["default"].propDoc), _class3.demoProps = [{
  demoDescription: "info",
  text: "some insightful info",
  size: 16,
  position: "top center",
  sentiment: "info"
}, {
  demoDescription: "error",
  text: "some insightful info",
  size: 16,
  position: "top center",
  sentiment: "error"
}, {
  demoDescription: "warning",
  text: "some insightful info",
  size: 16,
  position: "top center",
  sentiment: "warning"
}], _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "backgroundColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "backgroundColor"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "textColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textColor"), _class2.prototype)), _class2)) || _class;

var _default = Info;
exports["default"] = _default;